import { SharedUtil } from './../utils/SharedUtil';
import { StorageService } from './../../services/storage.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router,ActivatedRoute} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    
    constructor(
        private storage: StorageService,
        private global: SharedUtil,
    public routes: ActivatedRoute,
        private route: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError(error => {

                    if (!error.status) {
                        error = JSON.parse(error);
                    }
                    switch (error.status) {
                        case 403:
                            let aux:any;
                            this.global.getMessage('toast', false, 'error', 'Acesso Negado', "Sessão expirada, por favor efetue o login novamente.");
                            if(sessionStorage.getItem("infoAdmin")!=null){
                                aux="admin"
                            }else if(sessionStorage.getItem("infoAssistente")!=null){
                                aux="assistente";
                            }else if(sessionStorage.getItem("infoGestor")!=null) {
                                aux="gestor"
                            }else if(sessionStorage.getItem("infoGestor")!=null) {
                                aux = sessionStorage.getItem("rotaEleicao")
                            }else if(sessionStorage.getItem("infoAprovador")!=null){
                                this.route.navigate([sessionStorage.getItem("rotaEleicao")], { queryParams: { role: 'aprovador' } });
                            }else{
                                if(sessionStorage.getItem("viaIntegracao")!="true"){
                                    aux = sessionStorage.getItem("rotaEleicao")
                                }
                                else {
                                    let textoErro = sessionStorage.getItem("sessãoExpirada");
                                    sessionStorage.setItem("textoErro", textoErro);
                                    aux = 'acesso-negado';
                                }
                                console.log("role:eleitor  rota: "+ aux);
                            }
                            //this.storage.setLocalUser(null);
                            //this.storage.setEleicao(null)
                            //sessionStorage.clear();
                            sessionStorage.setItem('termoAceite', 'null'); 
                            this.route.navigate([aux])
                           //location.reload();
                            break;
                        case 404:
                            //let mensagem = error.error.message ? error.error.message : JSON.parse(error.error).message;                          
                            //this.global.getMessage('toast', false, 'error', 'Atenção', mensagem);                     
                            //this.storage.setLocalUser(null);
                            //this.storage.setEleicao(null)
                           // sessionStorage.clear();                          
                            //this.route.navigate(['login'])
                            break;
                        case 401:
                            if(sessionStorage.getItem("viaIntegracao")!=null){
                                aux="acesso-negado"
                                this.route.navigate(["../../acesso-negado"])
                            }
                            break;    
                        case 500:

                        console.log(this.route.url)
                        if(this.route.url != '/login'){                          
                                let mensagem = error.error.message ? error.error.message : JSON.parse(error.error).message;                          
                                this.global.getMessage('toast', false, 'error', 'Atenção', mensagem);                               
                                this.storage.setLocalUser(null);
                                this.storage.setEleicao(null)
                                sessionStorage.clear();
                                this.route.navigate(['login'])                        
                               // location.reload();   
                        }
                            break;

                    }
                    return throwError(error);
                })) as any;
    }

}

export const ErrorInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
};